namespace advisorop.components.servicer {
    

    class CompanyGroupListController {
        dg;
        public onCompanyGroupChanged: any;
        public companyGroups: Array<domains.ICompanyGroup>;

        static $inject = ["identityService","servicerService"];
        constructor(private identityService: services.IdentityService,
            private servicerService: services.ServicerService) {

            this.dg = {
                bindingOptions: {
                    dataSource: "vm.companyGroups"
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                //height: "350px",
                paging: { pageSize: 10 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,
                //stateStoring: {
                //    enabled: true,
                //    type: "localStorage",
                //    storageKey: "dgAdvisorsSettings"
                //},
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: 'Search...'
                },
                columns: [
                    { dataField: 'companyName', caption: 'Name', width: 250, cellTemplate: 'companyName' },
                    { dataField: 'contactFullName', caption: 'Contact', visible: false },
                    { dataField: 'fullAddress', caption: 'Address' },                    
                    { dataField: 'contactEmail', caption: 'E-mail', visible: false },
                    { dataField: 'id', caption: '#', cellTemplate: 'btnActions' }
                ],
                selection: {
                    mode: 'single',
                    showCheckBoxesMode: 'onClick'
                },
                onSelectionChanged: function (selectedItems) {
                    var data = selectedItems.selectedRowsData[0];
                    if (data) {
                        this.vm.onCompanyGroupChanged({ id: data.id });
                    }
                }
            };

        }
        
        getCompanyGroups(): void {            
            this.servicerService.getCompanyGroups()
                .success((data) => {
                    this.companyGroups = data;
                })
                .error((data, status) => {
                    toastr.error("COMPANY GROUPS ERROR " + status + " " + data );
                });
        }
        
        $onInit(): void {
            this.getCompanyGroups();
        }

        $routerOnActivate(next, previous) {
        }
    }



    class CompanyGroupList implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {    
                onCompanyGroupChanged: "&"                            
            };
            this.controller = CompanyGroupListController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/company-group-list.html';            
        }
    }
    angular.module(Constants.APP).component("companyGroupList", new CompanyGroupList());


}